module.exports = __webpack_public_path__ + "assets/fded17c78fd9fb4aa86299fd856a6620.png";